import React, { Component } from "react";
import { connect } from "react-redux";

import styles from "./style.module.scss";

class Results57 extends Component {
  // Renders the result section (predicted or actual)
  renderResultsSection = (results, sectionType) => {
    return (
      <div className={styles[`results__${sectionType}`]}>
        <h4 tabIndex={0}>{`${
          sectionType.charAt(0).toUpperCase() + sectionType.slice(1)
        } results`}</h4>
        <div className={styles[`results__${sectionType}__result`]}>
          {this.renderResultImages(results, sectionType)}
        </div>
      </div>
    );
  };

  // Renders the images for the result section
  renderResultImages = (results, sectionType) => {
    return ["experimental", "control"].map((key) => (
      <div key={key}>
        <img
          tabIndex={0}
          draggable={false}
          src={
            require(`./img/p-${key === "experimental" ? "plus" : "minus"}-${
              results[key] || "0"
            }.svg`).default
          }
          alt={
            this.props.aria[`p${key === "experimental" ? "+" : "-"}`][
              results[key] || 0
            ]
          }
        />
        {this.renderResultSpan(results[key], sectionType, key)}
      </div>
    ));
  };

  // Renders the correct/incorrect label
  renderResultSpan = (result, sectionType, key) => {
    const isCorrect =
      (sectionType === "predicted" && key === "experimental" && result === 4) ||
      (sectionType === "actual" && key === "control" && result === 2);

    return (
      <span
        tabIndex={0}
        className={styles[isCorrect ? "correct" : "incorrect"]}
      >
        {isCorrect ? "Correct." : "Incorrect."}
      </span>
    );
  };

  render() {
    const { predictions, actual } = this.props;

    return (
      <div className={styles.results}>
        {this.renderResultsSection(predictions, "predicted")}
        {this.renderResultsSection(actual, "actual")}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    predictions: state.transformingBacteria.predictions,
    actual: state.transformingBacteria.actual,
  };
};

export const TransformingBacteriaResults = connect(mapStateToProps)(Results57);
